import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const VEHICLE_TYPE_LABELS: Record<string, string> = {
  sedan: 'Sedan',
  suv: 'SUV',
  hatchback: 'Hatchback',
};

export function getVehicleTypeLabel(code: string | null | undefined): string {
  if (!code) return 'Any Vehicle';
  return VEHICLE_TYPE_LABELS[code] || code.charAt(0).toUpperCase() + code.slice(1);
}

/** Realtime filters on uuid columns break with a Postgres error when fed a
 * non-uuid value (e.g. a booking number). Guard every subscription with this. */
export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(value: unknown): value is string {
  return typeof value === 'string' && UUID_REGEX.test(value);
}
